import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BranchHttpService } from 'src/app/http/branch-http.service';
import { UserHttpService } from 'src/app/http/user-http.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styles: [],
})
export class UserListComponent implements OnInit {
    constructor(private activatedRoute: ActivatedRoute, private modalService: NgbModal, private userHttpService: UserHttpService, private router: Router) {}

    tempItems = [];

    items = [];

    totalItems = this.items.length;

    searchBoxControl = new FormControl();

    @ViewChild('table') table: DatatableComponent;

    @ViewChild(AlertComponent) alert: AlertComponent;

    ngOnInit(): void {
        this.routeData();
        this.routeHistory();
    }

    routeHistory() {
        if (history.state.hasState) {
            setTimeout(() => {
                this.alert.addAlert({ type: history.state.type, message: history.state.message });
            });
        }
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.items = data.data;
            this.tempItems = data.data;
        });
    }

    tableFiltring(event: any) {
        const val = event.target.value.toLowerCase();
        const temp = this.tempItems.filter(function (d) {
            return d.email.toLowerCase().indexOf(val) !== -1 || !val;
        });
        this.items = temp;
        this.table.offset = 0;
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this content item?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    confirmEnable(item: any, value: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = `${value ? 'Enable' : 'Disable'}`;
        confirm.componentInstance.messageLabel = `Are you sure you want to ${value ? 'enable' : 'disable'}  this item?`;
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.toggleEnable(item, value);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.userHttpService.deleteUserById(item.id).subscribe(() => {
            this.deleteItem(item.id);
            this.alert.addAlert({ type: 'success', message: 'User Deleted successfully' });
        });
    }

    toggleEnable(item: any, value: any) {
        this.userHttpService.toggleEnableUser(item.id, value).subscribe(() => {
            this.toggleEnableItem(item.id, value);
            this.alert.addAlert({ type: 'success', message: `User ${value ? 'enable' : 'disable'} successfully` });
        });
    }

    deleteItem(itemId: any) {
        this.tempItems = this.tempItems.filter((c) => c.id != itemId);
        this.items = this.tempItems;
    }

    toggleEnableItem(itemId: any, value: any) {
        let item = this.tempItems.find((c) => c.id === itemId);
        item.isEnabled = value;
        this.items = this.tempItems;
    }
}
